module.exports = "/static/assets/ae4fdf588b063e05cd99593e785dd60d.jpg";